import { Component, OnInit, Input, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ContentActionComponent } from 'src/app/shared/content-action/content-action.component';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { ActivatedRoute, Router } from '@angular/router';
import { Confirmation } from 'src/app/enums/confirmation.enum';
import { ErrorText } from 'src/app/enums/error-text.enum';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { FormControl, FormGroup } from '@angular/forms';
import { FilterFormModal, FilterValue } from 'src/app/models/form-group.model';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'fury-user-review-list',
  templateUrl: './user-review-list.component.html',
  styleUrls: ['./user-review-list.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class UserReviewListComponent implements OnInit {

  selectConfig = {disableOptionCentering: true,panelClass: 'custom-class'}
  @Input()
  columns = [
    {name: 'User Name', property: 'userName', visible: true},
    {name: 'User Location', property: 'userLocation', visible: true},
    {name: 'Review From', property: 'reviewFrom', visible: true},
    {name: 'Rating', property: 'rating', visible: true},
    {name: 'Review Text', property: 'reviewText', visible: true},
    {name: 'Status', property: 'status', visible: true},
    { name: 'Actions', property: 'actions', visible: true },
  ];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  itemList: any;
  filterValue: any;
  pageSize = 30;
  totalCount: number = 0;
  pageIndex: number = 0;
  searchedKeyword!: string;
  searchBy: string = 'userName';
  searchType: string = 'contains';
  isShowFilter: boolean = false;

  filterForm = new FormGroup<FilterFormModal>({
    searchBy: new FormControl(this.searchBy),
    searchType: new FormControl(this.searchType),
  });

  constructor(
    private apiservice: ApiService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public commonService: CommonService,
  ) {
    this.filterValue = 'User Review List';
    this.router.onSameUrlNavigation = 'reload';

    this.activatedRoute.queryParams.subscribe((res: any) => {
      this.pageIndex = res.page ? res.page - 1 : 0;
      this.searchedKeyword = res.keywords ? res.keywords : '';
      this.pageSize = res.size ? (res.size === 'all' ? 9999 : res.size) : 30;
      this.searchBy = res.searchBy ? res.searchBy : 'userName';
      this.searchType = res.searchType ? res.searchType : 'contains';
      this.filterForm.patchValue({
        searchBy: this.searchBy,
        searchType: this.searchType
      });     
      this.getReviewList();
    });
  }
  get visibleColumns() {
    return this.columns
      .filter((column) => column.visible)
      .map((column) => column.property);
  }
  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    
  }
  onFilterChange(value: string) {
    this.pageIndex = 0;
    this.searchedKeyword = value.trim();
    this.router.navigateByUrl(
      `/reputation/user-review-list?page=${this.pageIndex + 1
      }${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`
    );
    this.getReviewList();
  }
  pageSizeChange(event: any) {    
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.router.navigateByUrl(
      `/reputation/user-review-list?page=${this.pageIndex + 1
      }${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`
    );
    this.getReviewList();
  }

  getReviewList() {
    this.apiservice
      .get(
        `admin/user-review/get-all-user-reviews?page=${Number(this.pageIndex) + 1
        }&size=${this.pageSize}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''
        }&searchBy=${this.searchBy}&searchType=${this.searchType}`
      )
      .subscribe((res: any) => {
        if (res.body) {
          if (res.body?.userReviews?.data) {
            this.itemList = res.body?.userReviews?.data;
            this.totalCount = res.body.userReviews.total;
            this.dataSource = new MatTableDataSource(this.itemList);
            this.cdr.detectChanges();
          } else {
            this.itemList = undefined;
          }
        }
      });
  }
  openDialog(type: string, id: string){
    const dialogref = this.dialog.open(ContentActionComponent, { width: '500px', data: { type } });
    dialogref.afterClosed().subscribe((res: Confirmation) => {
      if (res === Confirmation.Yes) {
        this.apiservice.delete(`admin/user-review/delete-user-review/${id}`).subscribe({
          next: (del: any) => {
            if (del.body) {
              this.apiservice.alert(del.body.message, ErrorType.Success);
              this.getReviewList();
            }
          }, error: (err: HttpErrorResponse) => {
            if (err) {
              this.apiservice.alert(err?.message, ErrorType.Error);
            }
          }
        });
      }
    });
  }
  changeStatus(event: MatSlideToggleChange, row:any){
    this.apiservice.patch(`admin/user-review/change-status/${row?.userReviewId}`, { isActive: event.checked }).subscribe((res:any) =>{
      if(res?.body){
        this.apiservice.alert(res?.body?.message, ErrorType.Success);
      } else {
        row.isActive = !row.isActive;
        this.apiservice.alert(res.body.message, ErrorType.Warning);
      }
    }, err =>{
      this.apiservice.alert(err.message, ErrorType.Error);
      this.getReviewList();
    })
  }

  showFilter(){
    this.isShowFilter = !this.isShowFilter; 
  }
  serchByValue: FilterValue[] = [
    {title: 'User Name', value: 'userName'},
    {title: 'User Location', value: 'userLocation'},
    {title: 'Review From', value: 'reviewFrom'},
    {title: 'Rating', value: 'rating'},
    {title: 'Review Text', value: 'reviewText'}
  ];
  filterChange(){
    this.searchType = this.filterForm.value.searchType;
    this.searchBy = this.filterForm.value.searchBy;
    this.router.navigateByUrl(`/reputation/user-review-list?page=${this.pageIndex + 1}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`);
    this.isShowFilter = false;
    this.getReviewList();
  }


}
